import React from 'react';
import { capitalizeFirstLetter } from '../../../util/genericHelpers';
import { EnhancedServiceTypes, TalentPlusService } from '../../../util/enums';
import { FormattedMessage } from 'react-intl';
import { Icons, PrimaryButton } from '../../../components';
import classNames from 'classnames';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';

const BusinessDevelopment = ({ talentPlus, title, listing }) => {
  const mentorship = talentPlus?.filter(
    service => service?.service === TalentPlusService.BUSINESS_DEVELOPMENT
  );

  const availableItems =
    mentorship?.map(mentorShip => ({
      title:
        mentorShip.type === 'Custom' ? mentorShip.service : capitalizeFirstLetter(mentorShip.type),
      price: mentorShip.price,
    })) || [];

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const listingId = listing?.id?.uuid;

  const navigateToServiceOfferingsPage = item => {
    const pathname = createResourceLocatorString(
      'ServiceOfferingsPage',
      routeConfiguration,
      { id: listingId, type: EnhancedServiceTypes.BUSINESS_DEVELOPMENT },
      {}
    );

    history.push({
      pathname,
      state: { item }, // <-- send item in state
    });
  };

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          <FormattedMessage id="EnhancedServices.BusinessDevelopment.modelTitle" />{' '}
          <FormattedMessage id="SectionAppearances.from" values={{ title }} />
        </h2>
      </div>
      {availableItems.length > 0
        ? availableItems.map((item, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>{item.title}</h2>
                  <p>${Number(item.price).toFixed(2)} per hour</p>
                  <p>{getTalentServiceDescription(item?.title)}</p>
                  <PrimaryButton
                    className={css.bookBtn}
                    type="button"
                    onClick={() => navigateToServiceOfferingsPage(item)}
                  >
                    <Icons name="security" />
                    <FormattedMessage id="EnhancedServices.SectionExclusedTraining.buyNowButton" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
};

export default BusinessDevelopment;
